import React from 'react';
import { Badge, Tag } from 'antd';
import { decode } from 'html-entities';
import moment from 'moment';
import Linkify from 'react-linkify';
import * as resourceActions from 'ACTIONS/resources.actions';
import { DataGrid, DataGridFilters } from 'COMPONENTS/DataGrid';
import { getUIStatus } from 'HELPERS/utils';
import ControlResource from 'PAGES/Control/Resource/ControlResource';
import { Summary } from '../../Summary';
import GenerateCampaignForm from './GenerateCampaignForm';
import { store } from '../../../../App';

const filterClient = (id) => {
  const resource = 'generatePreview';
  const params = {
    client_id: id,
    page: 1,
    status_id: '',
    type_id: '2',
  };

  return store.dispatch(resourceActions.refetchResource(resource, params));
};

export const columns = [
  {
    title: 'Site Name',
    dataIndex: 'account',
    key: 'accounts.name',
    render: account => (
      <a target="_blank" rel="noreferrer" title="Access website" href={`https://${account.site}`}>
        {decode(account.name)}
      </a>
    ),
    sorter: true,
  },
  {
    title: 'Client',
    dataIndex: 'account',
    key: 'clients.name',
    render: ({ clients }) => (clients)
      && clients.map(client => (
        <Tag style={{ cursor: 'pointer' }} key={`client_${client.id}`} onClick={() => filterClient(client.id)}>
          {decode(client.name) || (client.cap_client_id || client.id)}
        </Tag>
      )),
    sorter: true,
  },
  {
    title: 'Mailchimp Account',
    dataIndex: 'account',
    key: 'accounts.mailchimp_account',
    render: account => account.mailchimp_account,
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status_id',
    width: 90,
    // eslint-disable-next-line
    render: ({ status }) => <Badge key="status_badge" status={getUIStatus(status)} text={status} />,
    sorter: true,
  },
  {
    title: 'Details',
    dataIndex: 'details',
    key: 'details',
    // eslint-disable-next-line
    render: ( details ) => (
      <Linkify key="details_linkify" properties={{ target: '_blank' }}>
        {details}
      </Linkify>),
    sorter: true,
  },
  {
    title: 'Last Update',
    dataIndex: 'updated_at',
    key: 'updated_at',
    render: value => moment(value).format('LLL'),
    sorter: true,
  },
];

// eslint-disable-next-line react/prop-types
const GenerateCampaign = () => (
  <ControlResource
    resource="generatePreview"
    resourceTypeId="2"
    title="Generate preview"
    renderBefore={
      () => (
        <Summary
          resource="generatePreview"
          resourceTypeId="2"
          lastUpdateMessage="Last preview generated on"
        />
      )
    }
    form={<GenerateCampaignForm />}
    filterForm={<DataGridFilters />}
  >
    <DataGrid
      columns={columns}
      search={null}
      tableProps={{
        rowKey: record => record.id,
        bordered: true,
      }}
    />
  </ControlResource>
);

export default GenerateCampaign;



// WEBPACK FOOTER //
// ./src/pages/Control/Screens/GenerateCampaign/GenerateCampaign.js